export default "__VITE_ASSET__Q1RguVLTsn1X_pNUE3gq4g__"